import store from '../store';
import SESSION_ACTIONS from '../actions/sessionActions';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

var idler = 0;
export default {
    sessionTimer: function() {
        return {
            run: function( time ) {
                var minutes = time * 1000;
                time = time || 20;
                setInterval( function() {
                    idler++;
                    if ( idler === time )
                        endSession();
                    else if ( idler === ( time - 1 ) )
                        endSessionNotice();
                    }
                , 60000 );
            },
            restart: function() {
                updateSessionExpiration();
                idler = 0;
            }
        }
    },
    logout: function() {
        // Using a standard vailla JavaScript AJAX request because I do not care about the
        // response and, therefore, do not want to wrap the request in the RSAA lifecycle. It
        // is, currently, not necessary. However, this request needs to go out before the
        // session is cleared, to it is set as synchronous, not asynchronous, deliberately.
        let http = new XMLHttpRequest();
        http.open( 'POST', ssCommonUtils.setEnvPrefix( '/session/logout' ) );
        http.setRequestHeader( 'Authorization', `Bearer ${ window.session.token }` );
        http.send();
    }
}

function updateSessionExpiration( updateHtmlSession ) {
    store.dispatch( { type: SESSION_ACTIONS.SET_SESSION_CURRENT } );
}

function endSession() {
    store.dispatch( { type: SESSION_ACTIONS.CLEAR_SESSION } );
}

function endSessionNotice() {
    store.dispatch( { type: SESSION_ACTIONS.SET_NOTICE, payload: 'pre-expiration-notice' } );
}
